import {createMachine, actions, send, assign} from "xstate";

const createRenameEntryFormMachine = () => {

    const validate = (value) => {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                if (!value) {
                    return reject(new Error('Please provide a title.'));
                }

                resolve(value);
            }, 250);
        });
    };

    return createMachine({
        id: 'rename-entry-form-machine',
        initial: 'editing',
        context: {
            validationErrorMessage: null,
            formErrors: []
        },
        states: {
            editing: {
                on: {
                    SUBMIT: 'validating'
                },
                initial: 'idle',
                states: {
                    idle: {},
                    invalid: {}
                }
            },
            validating: {
                onEntry: [
                    assign({
                        formErrors: (ctx, event) => []
                    })
                ],
                invoke: {
                    id: 'validating',
                    src: (_, {name}) => validate(name),
                    onDone: {
                        target: 'submitting',
                        actions: assign({
                            validationErrorMessage: null
                        })
                    },
                    onError: {
                        target: 'editing.invalid',
                        actions: assign({
                            validationErrorMessage: (ctx, event) => event.data.message
                        })
                    }
                }
            },
            submitting: {
                invoke: {
                    id: 'submit',
                    src: 'execRenameEntryRequest',
                    onDone: {
                        target: 'submitted'
                    },
                    onError: {
                        target: 'editing',
                        actions: assign({
                            formErrors: (ctx, event) => {
                                // debugger;
                                const { data } = event;
                                const { graphQLErrors } = data;
                                let errors = [];

                                for (let gqlError of graphQLErrors) {
                                    if (gqlError.extensions.category === 'validation') {
                                        const validationErrors = gqlError.extensions.validation;
                                        for (let property of Object.keys(validationErrors)) {
                                            errors = [
                                                ...errors,
                                                ...validationErrors[property]
                                            ];
                                        }
                                    }
                                }

                                if (errors.length === 0) {
                                    errors.push("Sorry, this entry could not be renamed at this time.");
                                }

                                return errors;
                            }
                        })
                    }
                }
            },
            submitted: {
                final: true,
                invoke: {
                    id: 'submit',
                    src: 'onDone',
                }
            }
        }
    });
};

export {createRenameEntryFormMachine};
